import type { ImageLoaderProps } from 'next/image'

/**
 * Custom image loader for Supabase images that bypasses Next.js Image Optimizer
 * to avoid 400 errors with remote setups
 */
export function supabaseImageLoader({ src }: ImageLoaderProps): string {
  // Loader returns the validated URL directly – without Optimizer
  return src
}